import { useContext } from 'react';
import { useStore } from 'zustand';

import type { AppState } from './appStore';
import { AppStoreContext } from './AppStoreContext';

export function useAppStore<T>(selector: (state: AppState) => T): T {
  const store = useContext(AppStoreContext);

  if (!store) {
    throw new Error('useAppStore must be used within AppStoreProvider.');
  }

  return useStore(store, selector);
}
